import React from 'react';
import autobind from 'autobind-decorator';

import {ProgramNameTableColumn} from '../../Pages/Programs/NameTableColumn';
import {StreamBankTable} from "../../Common/Table/StreamBankTable";

export const ProgramsTable = React.forwardRef((props, ref) => {

    const columnDefs =[
        {
            title: "Name",
            key: "name",
            sortable: true,
            logic: (x) => x.name,
            renderer: ProgramNameTableColumn
        }
    ];

    return <StreamBankTable
        columnDefs={columnDefs}
        itemNamePlural="programs"
        getKeyForRow={x => x.programId}

        sortColumn="created"
        sortAsc={false}

        ref={ref}

        {...props}

    />;
});



    